import { Pipe, PipeTransform } from '@angular/core';
import { remove } from 'remove-accents'; 'remove-accents'
import { PresupuestoDTO } from 'src/app/Models/ApiV2/DocumentoDTO';
import * as moment from 'moment';
const lodash = require('lodash');

@Pipe({
    name: 'buscarpresupuesto',
    standalone: true
})
export class BuscarPresupuestoPipe implements PipeTransform {
  
  transform(array:  PresupuestoDTO[],
    texto: string = '',
    fullArray: PresupuestoDTO[]
    
  ):  PresupuestoDTO[] {

    let arrayFiltrado:  PresupuestoDTO[] = []

    if (!array) {
      return array;
    }
    if (texto?.length == 0) {
      return array;
    }

    texto = remove(texto?.toLowerCase());
    console.log("texto buscar" ,texto)
    arrayFiltrado = fullArray
   


    let values = texto.split(' ');
    let acumulaFiltros:  PresupuestoDTO[] = []
    let acumuladoFinal:  PresupuestoDTO[] = []

    values.forEach((value, index) => {

      acumulaFiltros = arrayFiltrado.filter((documento : PresupuestoDTO) =>{
      return (
        // documento?.id.toString().includes(value) ||
        // documento?.registro.toString().includes(value) ||
        // remove(this.evaluar(documento?.serie?.serie.toLowerCase())).includes(value) ||
        remove(this.evaluar(documento?.nombre?.toLowerCase())).includes(value) ||
        moment(documento?.fecha).format('DD/MM/YYYY').includes(value)  


        // remove(this.evaluar(documento?.formaPago?.nombre?.toLowerCase())).includes(value)  
        // remove(this.evaluar(cliente?.datosFiscales?.nombre?.toLowerCase())).includes(value)||
        // remove(this.evaluar(cliente?.datosFiscales?.nombrePFisica?.toLowerCase())).includes(value) ||
        // remove(this.evaluar(cliente?.datosFiscales?.nif?.toLowerCase())).includes(value) ||
        // cliente?.telefonos?.filter(telefono => telefono.telefono.toLowerCase().includes(value)).length > 0 ||
        // cliente?.emails?.filter(email => email.email.toLowerCase().includes(value)).length > 0 ||
        // remove(this.evaluar(cliente?.datosFiscales?.domicilioFiscal?.poblacion?.nombre?.toLowerCase())).includes(value) ||
        // remove(this.evaluar(cliente?.datosFiscales?.domicilioFiscal?.provincia?.nombre?.toLowerCase())).includes(value) ||
        // remove(this.evaluar(cliente?.datosFiscales?.domicilioFiscal?.localidad?.nombre?.toLowerCase())).includes(value)
      );
      
    });
    if(index == 0) acumuladoFinal = acumulaFiltros
    else acumuladoFinal = lodash.intersectionBy(acumuladoFinal, acumulaFiltros, 'id')
    })
    return (acumuladoFinal.concat() )
  }

  evaluar(valor: string) : string {
    if (!valor) valor = "";
    return valor
  }

}
